module.exports = {
      id: "search-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-4990048fd6d3fd501089a0638bd441f8.svg#search",
      toString: function () {
        return this.url;
      }
    }